module.exports = __webpack_public_path__ + "img/thumb-006-04.c04edb60.png";